import { getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
import { initializeApp } from "firebase/app";
//https://console.firebase.google.com/project/typeathon/settings/general/web:MWY2NzZmOGQtMDY5Ni00ZTdhLWE0ZmEtNDExOGExYzQxMTYy

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC8ca4uWFJH4m5U2qdtTEInnOncsc2jceA",
  authDomain: "typeathon.firebaseapp.com",
  projectId: "typeathon",
  storageBucket: "typeathon.appspot.com",
  messagingSenderId: "151918572868",
  appId: "1:151918572868:web:c61834f762ffc3d8fe1311"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth=getAuth();
export const db=getFirestore(app);
export default app;